// extracted by css-extract-rspack-plugin
export default {"wrapper":"CampaignsSearch-module__wrapper--BxNko","inner-wrapper":"CampaignsSearch-module__inner-wrapper--TNEfR","innerWrapper":"CampaignsSearch-module__inner-wrapper--TNEfR"};